import { global } from '../../../globals/constants';

const airCargo = `${global.icons2}/air-cargo.png`;

export default function DetailsSection({ data }) {
  return (
    <>
      <div className='cargo-details-container'>
        <div className='cargo-details-sub'>
          <div className='cargo-details-img'>
            <img src={airCargo} alt='Air Cargo' width={48} />
          </div>
          <div className='cargo-details'>
            <div className='pkg-details'>
              {data?.pieceCount} Piece(s) | {data?.weight}
            </div>
            <h2>{data?.status}</h2>
          </div>
        </div>
        <div className='cargo-details-status'>{data?.currentStatus}</div>
      </div>
    </>
  );
}
